import { FILTER_TYPES, RECENT_SORT, DEFAULT_FILTER_TYPE } from '../../../constants';
import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

const mapFilterToType = {
    ...FILTER_TYPES,
    [DEFAULT_FILTER_TYPE]: RECENT_SORT,
};

export const reportEvent = (type, eventData) => {
    const { itemsCount, filterType } = eventData;

    sendBigQueryEvent(type.BigQuery, eventData);
    tracker.sendMixPanelEvent({
        eventName: type.Mixpanel,
        eventPayload: {
            'Sort Type': mapFilterToType[filterType],
            'Items Count': itemsCount,
        },
    });
};

const sendBigQueryEvent = (type, { filterType }) => {
    tracker.sendBQEvent(
        getBQClickFields({
            type,
            text: filterType,
            elementName: 'sort_by',
            componentName: 'reviews_header',
        })
    );
};

export const Events = {
    changeFilter: {
        BigQuery: 'clicked_on_sort_by',
        Mixpanel: 'Clicked Sorting Button',
    },
};
